import { useTranslation } from "react-i18next";
import { getProfileTabHref, getProfileTabs } from "./profileTabs.config";

export const ProfileTabsMobile = ({
  section,
  athlete,
  query,
  classNames,
  clientConfigurationPending,
}) => {
  const { t } = useTranslation("athlete-portal");
  const organizationCoach = query.organizationCoach || undefined;

  return (
    <div className="mobile-profile-tab">
      <ul role="toggle-links" classNames={classNames}>
        {getProfileTabs(athlete).map((tab) => (
          <li
            key={tab.section}
            className={section === tab.section ? "active" : ""}
          >
            <a
              data-button-type={
                section === tab.section ? "outline" : "text-white"
              }
              role="button"
              href={getProfileTabHref(tab.section, athlete, organizationCoach)}
            >
              {tab.section === "client-configuration" ? (
                <>
                  <span
                    style={{
                      display: "inline-block",
                      backgroundColor: "var(--danger)",
                      color: "#fff",
                      borderRadius: "var(--border-radius-md)",
                      padding: "2px 8px",
                      marginRight: "8px",
                      fontSize: "0.7em",
                      fontWeight: 700,
                      letterSpacing: "0.02em",
                      verticalAlign: "middle",
                    }}
                  >
                    {t("profile.clientConfigurationNewBadge")}
                  </span>
                  {t(tab.labelKey)}
                  {clientConfigurationPending && (
                    <span
                      role="img"
                      aria-label={t("profile.clientConfigurationPending")}
                      title={t("profile.clientConfigurationPending")}
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: "1.2em",
                        height: "1.2em",
                        marginLeft: "8px",
                        borderRadius: "50%",
                        backgroundColor: "rgba(247, 182, 0, 0.25)",
                        color: "var(--warning)",
                        fontSize: "0.75em",
                        fontWeight: 700,
                        verticalAlign: "middle",
                      }}
                    >
                      !
                    </span>
                  )}
                </>
              ) : (
                t(tab.labelKey)
              )}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};
